import { Cookies } from "./services/api-utils/cookies";

export const hasSession = () => {
  const session = Cookies.get("Authorization");
  const refreshToken = Cookies.get("powerhub_refresh_token");

  return session !== undefined && refreshToken !== undefined;
};

export const getToken = () => {
  return Cookies.get("Authorization");
};

export const setSession = (token: string) => {
  Cookies.set("Authorization", token);
};

export const removeToken = () => {
  Cookies.delete("Authorization");
};
